import { render } from "./PaymentNotice.vue?vue&type=template&id=b2fbdd90&scoped=true"
import script from "./PaymentNotice.vue?vue&type=script&lang=js"
export * from "./PaymentNotice.vue?vue&type=script&lang=js"

import "./PaymentNotice.vue?vue&type=style&index=0&id=b2fbdd90&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fbdd90"]])

export default __exports__